export const generateIdentifier = (str: string) => {
  return str
    .split(" ")
    .map((n) => n[0])
    .join("");
};
